import { Modal } from '@chikara/ui';
import { useState } from 'react';
import { MetadataNameInput } from '@/features/card/components/CardDetailPage/MetadataNameInput';
import styles from '@/features/card/pages/CardDetailPage/CardDetailPage.module.css';
import { t } from '@/i18n';

interface CreateTagModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: (name: string) => Promise<void>;
}

export const CreateTagModal = ({
    isOpen,
    onClose,
    onSave,
}: CreateTagModalProps) => {
    const [tagName, setTagName] = useState('');

    const handleSave = async () => {
        if (tagName.trim()) {
            await onSave(tagName.trim());
            setTagName('');
            onClose();
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            isActionDisabled={!tagName.trim()}
            onClose={onClose}
            title={t('dashboard.card.detail.modals.createTag.title')}
            description={
                <div className={styles.editAliasContent}>
                    <p className={styles.editAliasDescription}>
                        {t('dashboard.card.detail.modals.createTag.description')}
                    </p>
                    <MetadataNameInput
                        label={t('dashboard.card.detail.modals.createTag.label')}
                        value={tagName}
                        onChange={setTagName}
                        autoFocus
                    />
                </div>
            }
            actionLabel={t('dashboard.card.detail.modals.createTag.save')}
            onAction={handleSave}
            closeOnOverlayClick={true}
            closeOnEsc={true}
            showCloseButton={true}
        />
    );
};
